import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putUsers, putUsersRole } from '@/services';
import { useParams } from 'react-router-dom';
import PopChangeRol from '../change-rol';

type Props = {
  value: string;
};

export function DialogChangeRol({value}: Props) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();


  const { mutateAsync, } = useMutation({
    mutationFn: putUsersRole(value),
    onSuccess: (data: any) => {
      queryClient.setQueryData(['users', data?.id || ''], data);
      queryClient.invalidateQueries({ queryKey: ['users'] });
      enqueueSnackbar('Edit success user!');
    },
    onError: (error: any) => {
      enqueueSnackbar(error, { variant: 'error' });
    },
  });


  return <PopChangeRol onSave={mutateAsync} />;
}
